import { useState, useRef } from "react";
import GenericChatbot from "../components/GenericChatbot";
import HgChatbot from "../components/HgChatbot";

const MainPage = () => {
  const [showHgChatbot, setShowHgChatbot] = useState(false);
  const hgChatbotRef = useRef<HTMLDivElement | null>(null);
  const mainPageRef = useRef<HTMLDivElement | null>(null);

  const handleDiscoverClick = () => {
    setShowHgChatbot(true);
    setTimeout(() => {
      hgChatbotRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  const handleGoBackClick = () => {
    if (mainPageRef.current) {
      mainPageRef.current.scrollIntoView({ behavior: "smooth" });
      setTimeout(() => {
        setShowHgChatbot(false);
      }, 500);
    } else {
      setShowHgChatbot(false);
    }
  };

  return (
    <div className="main" ref={mainPageRef}>
      <GenericChatbot
        onDiscoverClick={handleDiscoverClick}
        showHgChatbot={showHgChatbot}
      />

      {showHgChatbot && (
        <div ref={hgChatbotRef}>
          <HgChatbot onGoBackClick={handleGoBackClick} />
        </div>
      )}
    </div>
  );
};

export default MainPage;
